import React from 'react';
import { config } from '@uhg-abyss/web/tools/config';
import { LagoonContext } from '@src/AppContext/LagoonContext';
import { IdleUser } from './IdleUser';

export const SessionTimeout = () => {
  const lagoonContext = React.useContext(LagoonContext);
  const featureToggles = lagoonContext.getTable('feature-toggles');
  const useUpdatedAuth = featureToggles.getRow(
    'US10732847_UPDATED_CORE_V2_ENDPOINTS'
  )?.active;

  const uiMessages = lagoonContext.getTable('ui-messaging');

  const onLogout = () => {
    const baseOidcUrl =
      uiMessages.getRow('OIDC_API_URL')?.message || config('OIDC_API_URL');
    const logoutPath = useUpdatedAuth ? '/logout/v2' : '/logout';
    window.location = `${baseOidcUrl}${logoutPath}`;
  };

  const handleLogout = async () => {
    onLogout();
  };

  const events = {
    onSignout: () => {
      if (config('APP_ENV') !== 'local') {
        handleLogout();
      }
    },
  };

  return (
    <React.Fragment>
      <IdleUser events={events} />
    </React.Fragment>
  );
};
